// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if ({928:1,955:1}[chunkId]) return "static/css/87569dd839f0af18.css";
	if (chunkId === 405) return "static/css/9ff0d67964360318.css";
	// return url for filenames based on template
	return undefined;
};